import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEvent = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.5486 7.71666L8.54124 13.5053C8.1739 14.0353 7.34257 13.776 7.34257 13.1307V9.31533H3.99257C3.4619 9.31533 3.14924 8.71933 3.4519 8.28266L7.45924 2.49399C7.82657 1.96399 8.6579 2.22333 8.6579 2.86866V6.68399H12.0079C12.5379 6.68399 12.8506 7.27999 12.5486 7.71666Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export { SvgEvent as ReactComponent };
